import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";

import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import DarkButton from "./DarkButton";
import GlobalApi from "./";
import refresh_token from "./refresh_token";
import Spinner from './Spinner'
export default function FormDialog(props) {
  const [show,setVisible] = React.useState(props.show? props.show : false);
   React.useEffect(()=>{
       if(show == props.show)
       return
       else
       setVisible(props.show)
   })
  return (
    <Dialog open={show} onClose={() => {}} aria-labelledby="form-dialog-title"  PaperProps={{
        style: {
          backgroundColor: 'transparent',
          boxShadow: 'none',
        },
      }}>
      <DialogContent >
        <Grid container style={{width:200}}>
          <Spinner/>
        </Grid>
      </DialogContent>
      {/* <DialogActions>
        <DarkButton
          size="large"
          onClick={(e) => {
            handleSubmit(e);
          }}
          disabled={!value}
          style={!value ? { backgroundColor: "gray" } : {}}
          type="submit"
        >
          submit
        </DarkButton>
      </DialogActions> */}
    </Dialog>
  );
}
